// @flow
import type { ErrorsPack } from '../../../components/initErrorsFromResponse'
import store from '../../store'
import * as actions from './reducers'

function putErrors(index: number, errors: ErrorsPack) {
  store.dispatch(
    actions.patch(index, {
      columnImageErrors: errors.mediaErrors.columnImageErrors,
      multiImageErrors: errors.mediaErrors.multiImageErrors,
      videoErrors: errors.mediaErrors.videoErrors,
      snippetImageErrors: errors.commonErrors.snippetImageErrors,
      vkBigImageErrors: errors.mediaErrors.vkBigImageErrors,
      tmSmallImageErrors: errors.mediaErrors.tmSmallImageErrors
    })
  )
}

export { putErrors }
